module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_braveM_m.9da290d028355b8f712f91942077a5b0.png";